import { useCallback, useState } from "react";
import { getInternalTransferBalance } from "services/internal-transfer-service";

export const useCompanyBalance = () => {
    const [balance, setBalance] = useState(null);

    const load = useCallback(async (companyId, parent) => {
        if (!companyId) {
            setBalance(null);
            return;
        }
        setBalance({ loading: true, companyId });
        const value = await getInternalTransferBalance(companyId, parent);
        setBalance((current) => {
            if (!current || current.companyId !== companyId) {
                return current;
            }
            return value === null || value === undefined ? null : { loading: false, companyId, value };
        });
    }, []);

    return [balance, load];
};

export const validateTransfer = ({ fromId, toId, amount, fromBalance }) => {
    if (!fromId || !toId) {
        return "Selecione a origem e o destino.";
    }
    if (fromId === toId) {
        return "Origem e destino devem ser diferentes.";
    }
    if (!amount || amount <= 0) {
        return "Informe um valor maior que zero.";
    }
    if (fromBalance && !fromBalance.loading && amount > fromBalance.value) {
        return "Valor maior que o saldo da empresa de origem.";
    }
    return null;
};
